// Generated on 2026-06-06T17:30:01.269Z
// This file contains preloaded products top brands data from the API
// Do not edit manually - use 'npm run generate:products-top-brands-data' to regenerate

export const preloadedProductsTopBrands: any = [
  {
    "marca": "DORMAN",
    "cantidadProductosVendidos": "48410"
  },
  {
    "marca": "NAKAMOTO",
    "cantidadProductosVendidos": "35353"
  },
  {
    "marca": "GSP NORTH AMERICA",
    "cantidadProductosVendidos": "34167"
  },
  {
    "marca": "WAGNER QUICKSTOP",
    "cantidadProductosVendidos": "27281"
  },
  {
    "marca": "FEBEST",
    "cantidadProductosVendidos": "24233"
  },
  {
    "marca": "ONNURI",
    "cantidadProductosVendidos": "22787"
  },
  {
    "marca": "VALVOLINE",
    "cantidadProductosVendidos": "22007"
  },
  {
    "marca": "BANDO",
    "cantidadProductosVendidos": "21107"
  },
  {
    "marca": "DENSO",
    "cantidadProductosVendidos": "18924"
  },
  {
    "marca": "DNJ",
    "cantidadProductosVendidos": "17961"
  },
  {
    "marca": "MAHLE ORIGINAL",
    "cantidadProductosVendidos": "17458"
  },
  {
    "marca": "BECK/ARNLEY",
    "cantidadProductosVendidos": "15093"
  },
  {
    "marca": "ECOGARD",
    "cantidadProductosVendidos": "13596"
  },
  {
    "marca": "555",
    "cantidadProductosVendidos": "11776"
  },
  {
    "marca": "FAG",
    "cantidadProductosVendidos": "11741"
  },
  {
    "marca": "BLUE PRINT",
    "cantidadProductosVendidos": "11653"
  },
  {
    "marca": "PRESTONE",
    "cantidadProductosVendidos": "10851"
  },
  {
    "marca": "DAYCO",
    "cantidadProductosVendidos": "10787"
  },
  {
    "marca": "PT",
    "cantidadProductosVendidos": "10266"
  },
  {
    "marca": "MOOG",
    "cantidadProductosVendidos": "9452"
  },
  {
    "marca": "MOTORAD",
    "cantidadProductosVendidos": "9406"
  },
  {
    "marca": "TENACITY",
    "cantidadProductosVendidos": "9198"
  },
  {
    "marca": "MOOG EU",
    "cantidadProductosVendidos": "8279"
  },
  {
    "marca": "HS",
    "cantidadProductosVendidos": "8210"
  },
  {
    "marca": "STANDARD/INTERMOTOR",
    "cantidadProductosVendidos": "8014"
  },
  {
    "marca": "DORMAN PREMIUM",
    "cantidadProductosVendidos": "7776"
  },
  {
    "marca": "NATIONAL",
    "cantidadProductosVendidos": "7710"
  },
  {
    "marca": "WAGNER",
    "cantidadProductosVendidos": "7581"
  },
  {
    "marca": "WALKER",
    "cantidadProductosVendidos": "7569"
  },
  {
    "marca": "EAGLE BHP",
    "cantidadProductosVendidos": "6524"
  }
];

export default preloadedProductsTopBrands;
